import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const AgreedPlaceIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M19.373 11.773 18 13.227l-1.314-1.24V15H24v2h-1v4h-1v-4h-5.314v3a1 1 0 0 1-1 1h-12a1 1 0 0 1-1-1v-8.014l-1.313 1.24L0 11.773l9.687-9.148zM21 21h-3v-2h3zM4.687 10.097V19h10v-8.902l-5-4.723z"
    />
  </BaseIcon>
)
